import { Severity } from '@sentry/types';
import loadGMapsAPI from 'load-google-maps-api';
import { merge, pathOr } from 'lodash/fp';
import { useEffect, useState } from 'react';

import { captureException } from './sentry';

const GMapsKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;

export const LoadGMapsServices = (options: any) =>
  loadGMapsAPI(merge(options, { key: GMapsKey }));

export const geocodeAddress = async (
  address: string
): Promise<google.maps.GeocoderResult | null> => {
  return new Promise(async resolve => {
    const GMapsServices = await LoadGMapsServices({
      libPath: [],
      libraries: [],
    });

    const geoCoder = new GMapsServices.Geocoder();
    geoCoder.geocode(
      { address, componentRestrictions: { country: 'US' } },
      (results, status) => {
        if (status === 'OK' && results) {
          const [address] = results;
          resolve(address || null);
        } else {
          resolve(null);
        }
      }
    );
  });
};

export const useGMapsServices = ({
  libPath,
  ...options
}: UserGMapsServicesConfig) => {
  const [GServices, setGServices] = useState<any>(undefined);
  const loadPlacesServices = async () => {
    try {
      const Services = await LoadGMapsServices(options);
      setGServices(() => pathOr(Services, libPath, Services));
    } catch (e) {
      captureException(
        e,
        Severity.Critical,
        () => 'Error loading Google bindings'
      );
    }
  };
  useEffect(() => {
    loadPlacesServices();
  }, []);

  return GServices;
};

interface UserGMapsServicesConfig {
  [key: string]: any;
  libPath: string[];
}
